import {Grid, Box} from '@jobseeker/lotus/foundations';
import {useWrappedTheme} from '@jobseeker/lotus/hooks';

import {Link} from './styles';
import {Image} from '@jobseeker/lotus/components/Image';
import {v4 as uuidv4} from 'uuid';

import type {Props} from './types';
import {openUrl} from '@jobseeker/common-core/utils';

const Footer = (props: Props) => {
  const theme = useWrappedTheme();
  return (
    <Box
      display="flex"
      alignItems={'center'}
      justifyContent={'center'}
      sx={{
        backgroundColor: props.bgcolor || 'secondary.main',
      }}
    >
      <Grid
        container
        sx={{
          justifyContent: {xxs: 'center', sm: 'space-between'},
          backgroundColor: props.bgcolor || 'secondary.main',
          display: 'flex',
          maxWidth: 1440,
          width: '100%',
          alignItems: 'center',
          paddingLeft: {sm: theme.spacing(2), xxl: theme.spacing(0)},
          paddingRight: {sm: theme.spacing(2), xxl: theme.spacing(0)},
        }}
      >
        <Grid item>
          <Box
            flexDirection="column"
            display="flex"
            alignItems={{xxs: 'center', md: 'start'}}
          >
            <Box py={theme.spacing(2)}>
              <Image
                src={props.logoUrl}
                alt={`logo_${process.env.NEXT_PUBLIC_APP_NAME}`}
                width={120}
                height={48}
                style={{
                  filter: 'brightness(10)',
                }}
              />
            </Box>
            <Box display={'flex'}>
              {props.socialLinks?.map((sl, index) => (
                <Link
                  isButton={sl.isButton}
                  href={sl.url}
                  elIndex={index}
                  target="_blank"
                  key={`sociallink-footer-${index}`}
                  aria-label={sl.label}
                  onClick={(e: React.MouseEvent) => {
                    e.preventDefault();
                    if (sl.url) {
                      setTimeout(() => {
                        openUrl(sl.url, '_blank');
                      }, 0);
                    }
                  }}
                >
                  {sl.icon}
                </Link>
              ))}
            </Box>
          </Box>
        </Grid>
        <Grid
          item
          sx={{
            alignItems: 'center',
            mt: {xxs: 5, sm: theme.spacing(3)},
          }}
        >
          <Grid
            container
            columnSpacing={{xxs: 4, md: 6, lg: 16}}
            rowSpacing={5}
            sx={{
              justifyContent: {xxs: 'center', sm: 'space-between'},
            }}
          >
            {Array(Math.ceil((props.columnLinks?.length || 5) / 5))
              .fill('')
              .map((_, index) => (
                <Grid
                  item
                  sx={{
                    textAlign: {xxs: 'center', sm: 'left'},
                  }}
                  key={`footer-column-grid-${uuidv4()}`}
                >
                  <Box
                    sx={{
                      flexDirection: 'column',
                      display: 'flex',
                    }}
                  >
                    {props.columnLinks
                      ?.slice(index * 5, index * 5 + 5)
                      .map((sl, i) => (
                        <Link
                          isButton={sl.isButton}
                          href={sl.url}
                          target="_blank"
                          key={`footer-column-link-${uuidv4()}`}
                          sx={{
                            paddingBottom: {lg: theme.spacing(1)},
                            margin: theme.spacing(0),
                          }}
                          onClick={(e: React.MouseEvent) => {
                            e.preventDefault();
                            if (sl.url) {
                              setTimeout(() => {
                                openUrl(sl.url, '_blank');
                              }, 0);
                            }
                          }}
                        >
                          {sl.icon}
                          <p style={{fontSize: theme.typography.pxToRem(14)}}>
                            {sl.label}
                          </p>
                        </Link>
                      ))}
                  </Box>
                </Grid>
              ))}
            <Grid
              item
              sx={{
                textAlign: {xxs: 'center', sm: 'left'},
              }}
              key={`footer-other-links-${uuidv4()}`}
            >
              <Box
                sx={{
                  flexDirection: 'column',
                  display: 'flex',
                }}
              >
                {props.otherLinks?.map(ol => (
                  <Link
                    href={ol.url}
                    target="_blank"
                    key={`footer-other-link-${uuidv4()}`}
                    sx={{
                      paddingBottom: {lg: theme.spacing(1)},
                      margin: theme.spacing(0),
                    }}
                    onClick={(e: React.MouseEvent) => {
                      e.preventDefault();
                      if (ol.url) {
                        setTimeout(() => {
                          openUrl(ol.url, '_blank');
                        }, 0);
                      }
                    }}
                  >
                    <p style={{fontSize: theme.typography.pxToRem(14)}}>
                      {ol.label}
                    </p>
                  </Link>
                ))}
              </Box>
            </Grid>
          </Grid>
        </Grid>
        <Grid
          item
          xxs={12}
          sx={{
            mt: 5,
            mb: theme.spacing(2),
            p: 1,
            display: 'flex',
            flexWrap: 'wrap',
            justifyContent: {
              xxs: 'center',
              sm: 'space-between',
              md: 'space-between',
            },
            textAlign: 'center',
            fontSize: theme.typography.pxToRem(14),
            color: '#fff',
            alignContent: 'center',
            paddingLeft: {
              sm: theme.spacing(3.5),
              md: '0px',
            },
          }}
        >
          {props.headerLabel?.replace(
            '{{year}}',
            new Date().getFullYear().toString()
          )}

          {/* <Box>
            {props.bottomLinks?.map((bl, index) => (
              <BottomLink
                key={index}
                href={bl.url}
                sx={{backgroundColor: 'transparent', color: '#fff'}}
              >
                {bl.label}
              </BottomLink>
            ))}
          </Box> */}
        </Grid>
      </Grid>
    </Box>
  );
};

export default Footer;
